import MainHeading from "../typeComponents/MainHeading";
import Paragraph from "../typeComponents/Paragraph";
import TextBlock from "../typeComponents/TextBlock";
import CureLogoCleanVector from "../images/CURE_logo_clean_vector.svg";
import { Box, List, ListItem, Link } from "@mui/material";

const Hiring = () => {
  return (
    <>
      <TextBlock>
        <MainHeading>Hiring a trans community outreach assistant!</MainHeading>
        <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
          <img src={CureLogoCleanVector} alt="CURE Montreal Logo" />
        </Box>
        <Paragraph>
          Are you a Concordia undergrad (or recent graduate), with an interest
          in community organizing? Are you a trans student hoping to help your
          own community, on campus and across the city? Want to get real-world
          experience bringing together trans orgs on a province-wide project?
        </Paragraph>
        <Paragraph>
          We want to hear from you! CURE is hiring a <b>trans student</b> to be
          our new <b>community outreach assistant</b>.
        </Paragraph>
        <Paragraph>
          This is a student job and we understand applicants will have limited
          experience. Please apply even if you're uncertain — we're accepting
          applicants from all levels of experience!
        </Paragraph>
        <Paragraph noIndent={true} extraSx={{ marginTop: "30px" }}>
          <b>You'll be helping our all-trans community team:</b>
          <List>
            <ListItem>
              - Liaise with community orgs and medical professionals
            </ListItem>
            <ListItem>
              - Organize focus groups to understand the needs of Montreal’s
              trans population
            </ListItem>
            <ListItem>
              - Write grant applications and technical documents
            </ListItem>
            <ListItem>- Stay on top of general admin</ListItem>
          </List>
        </Paragraph>
        <Paragraph noIndent={true} extraSx={{ marginTop: "0px" }}>
          <b>Things that are pluses for the job:</b>
          <List>
            <ListItem>
              - Solid admin skills, good at emails, researching, note-taking,
              and following up on things
            </ListItem>
            <ListItem>- Community experience</ListItem>
            <ListItem>- Health sector interest</ListItem>
            <ListItem>- Bilingual (English + French)</ListItem>
          </List>
          &emsp; Not having any one of those isn’t disqualifying, so please
          apply even if not all might apply to you!
        </Paragraph>
        <Paragraph
          noIndent={true}
          extraSx={{ marginTop: "17px", marginBottom: "30px" }}
        >
          <b>The nitty gritty:</b>
          <List>
            <ListItem>
              - Deadline to apply: <b>Sunday, November 15th by 11:59p.m.</b>
            </ListItem>
            <ListItem>
              - Job starts immediately & runs through the spring semester (with
              a possibility to renew for the summer).
            </ListItem>
            <ListItem>
              - Pay: <b>$25/hour, 11 hours/week.</b>
            </ListItem>
            <ListItem>
              - The form below is the full application - no resume required! 😊
            </ListItem>
            <ListItem>
              - Need to be available for team meetings every Monday afternoon.
            </ListItem>
          </List>
        </Paragraph>
        <Paragraph>
          If you don't see the form below or if it's not rendering for whatever
          reason, try it at{" "}
          <Link
            color={"text.primary"}
            // TODO Currently there is no responder link, as the form is unpublished! This needs to be filled in!
            href=""
          >
            <b>this link</b>
          </Link>{" "}
          or send us an email at{" "}
          <a href="mailto:curemontreal@gmail.com">curemontreal@gmail.com</a>!
        </Paragraph>
        {/* //* DESKTOP ONLY */}
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <iframe
            title="CURE 2026 Community Outreach Assistant Hiring"
            src="https://docs.google.com/forms/d/e/1FAIpQLSe_Jg5qtZJD_jBUVzjS6ZQeORIUUdzqTM7744Xsc_r27vTG0w/viewform?embedded=true"
            width="640"
            // TODO As the form is unpublished, we don't know what height it needs to be yet !
            height="6450"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </Box>
        {/* //* MOBILE ONLY */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <iframe
            title="CURE 2026 Community Outreach Assistant Hiring"
            src="https://docs.google.com/forms/d/e/1FAIpQLSe_Jg5qtZJD_jBUVzjS6ZQeORIUUdzqTM7744Xsc_r27vTG0w/viewform?embedded=true"
            width="375"
            // TODO As the form is unpublished, we don't know what height it needs to be yet !
            height="9000"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </Box>
      </TextBlock>
    </>
  );
};
export default Hiring;
